var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMoodStroke4 = function SvgMoodStroke4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54.442,
    height: 54.442,
    viewBox: "0 0 54.442 54.442",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_723",
    "data-name": "Caminho 723",
    d: "M45.283,44.248A27.229,27.229,0,1,1,30.306,58.734,27.118,27.118,0,0,1,45.283,44.248Zm19.476,3.464A23.835,23.835,0,1,0,77.426,60.817,23.764,23.764,0,0,0,64.759,47.712Zm1.623,28.746a1.7,1.7,0,1,1,3.054,1.474,15.754,15.754,0,0,1-28.337,0,1.7,1.7,0,0,1,3.054-1.474,12.356,12.356,0,0,0,22.229,0Z",
    transform: "translate(-28.046 -42.345)",
    stroke: "none"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoodStroke4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moodStroke4.2afc55f6.svg";
export { ForwardRef as ReactComponent };